import { DesignSystem } from '@/src/design-system'

export function BenefitsSkeleton() {
  return (
    <DesignSystem.Skeleton.Skeleton
      style={{ width: '100%', height: 380, overflow: 'hidden', borderRadius: 16 }}
    />
  )
}
